/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import unique from '../../../lib/unique-id/unique-id';
export default (function (tabCount) {
  var tabKeys = [];

  for (var i = 0; i < tabCount; i++) {
    tabKeys[i] = {
      tabKey: unique(),
      panelKey: unique()
    };
  }

  return tabKeys;
});